import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Title,
  createStyles,
  Text,
  Select,
  Button,
  Tabs,
  Input,
  Loader,
} from "@mantine/core";

import GenericInfoModal from "../../components/GenericInfoModal";
import pauseSvg from "../../assets/img/pause.svg";
import { data, generateHl7MessageBot, hl7Bot, modalSteps } from "./Hl7Services";
import { useMedplum } from "@medplum/react";
import { log } from "console";
import JSONPretty from "react-json-pretty";
import { showNotification } from "@mantine/notifications";

const useStyles = createStyles(() => ({
  paper: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingBottom: "40px",
  },
  title: {
    marginTop: "15px",
    fontWeight: 600,
    fontSize: "22px",
    lineHeight: "30px",
    color: "#262930",
    paddingTop: "12px",
    paddingBottom: "17px",
  },
  box1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  text: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#474E5B",
  },
  title1: {
    paddingLeft: "8px",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#262930",
  },
  button: {
    color: "#262930",
    fontWeight: 500,
    fontSize: "14px",
  },
  row: { display: "flex", flexDirection: "row" },
}));

export const Trigger = () => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  const [text, setText] = useState<any>("");
  const [connectDisable, setConnectDisable] = useState<boolean>(true);
  const [value, setValue] = useState<any>(null);
  const [showTabs, setShowTabs] = useState<boolean>(false);
  const [showInfoModal, setShowModal] = useState(false);
  const [hl7Message, sethl7Message] = useState<any>("");
  const [resource, setResource] = useState<any>();
  const [resourceType, setResourceType] = useState<any>();

  const [loading, setLoading] = useState<boolean>();
  const [modalData, setModalData] = useState({
    title: "",
    sideTitle: "",
    details: [] as any,
    confirmText: "",
    onClose: () => {},
    onConfirm: () => {},
  });
  const [fhirData, setfhirData] = useState<any>();

  useEffect(() => {
    generateHl7Message();
  }, [value]);

  const generateHl7Message = async () => {
    try {
      setLoading(true);
      const payload = {
        messageType: value,
      };
      const response = await generateHl7MessageBot(medplum, payload);
      const randomIndex = Math.floor(
        Math.random() * response?.messages?.length
      );

      // Store the random message in a variable
      const randomMessage = response?.messages[randomIndex];

      sethl7Message(randomMessage);
      setLoading(false);
    } catch (error) {
      console.error(error);
      showNotification({
        color: "red",
        message: "Failed ",
        autoClose: true,
      });
      setShowModal(false);

      setLoading(false);
    }
  };

  const onSelectChange = (val: any) => {
    setValue(val);
    setShowTabs(false);
    setConnectDisable(false);
    setResource([]);
    setResourceType("");
    console.log(val, "val");
  };

  const ConnectHl7 = async () => {
    try {
      if (!hl7Message) {
        showNotification({
          color: "red",
          message: "HL7 message not available for selected HL7 type",
          autoClose: true,
        });
        setShowModal(false);

        return;
      }
      const response = await hl7Bot(medplum, hl7Message);
      const responseBody =
        (typeof response === "object" && response !== null) ||
        Array.isArray(response)
          ? response
          : JSON.parse(response);

      // const responsebody = JSON.parse(response);
      const responsebody =
        (typeof response === "object" && response !== null) ||
        Array.isArray(response)
          ? response
          : JSON.parse(response);

      if (responsebody.status === 200) {
        const observations = responsebody.body.fhir;

        if (Array.isArray(observations)) {
          observations.forEach((observation: any) => {
            const resourceType = observation?.resourceType;

            setResourceType(resourceType);
          });
        } else {
          if(value==="BAR"){
            
            setResourceType(responsebody?.body?.fhir?.coverage?.resourceType);
          }else{
          setResourceType(responsebody?.body?.fhir?.resourceType);

          }
        }
        setResource(responsebody);
        setShowTabs(true);
      } else {
        console.error("Unexpected response format", responsebody);
        showNotification({
          color: "red",
          message: "Unexpected response format",
          autoClose: true,
        });
        setShowModal(false);

        return;
      }
    } catch (error) {
      setShowTabs(false);
      console.error(error);
      setShowModal(false);
      showNotification({
        color: "red",
        message: "Failed",
        autoClose: true,
      });

      return;
    }
  };

  const connect = () => {
    try {
      setShowModal(true);
      setModalData({
        title: "Please wait, we are parsing the HL7 message",
        sideTitle: "",
        details: [
          { label: "Title", text: "" },
          { label: "Description", text: "" },
        ],
        confirmText: "Proceed",
        onClose: () => {
          setShowModal(false);
        },
        onConfirm: async () => {
          const res = await ConnectHl7();
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Paper className={classes.paper}>
      <Title className={classes.title}>HL7 Trigger</Title>
      <Box>
        <Box className={classes.box1}>
          <Box className={classes.box1}>
            <Select
              placeholder="Select your HL7 V2 Trigger"
              size="lg"
              value={value}
              data={data}
              sx={{ minWidth: "500px" }}
              onChange={onSelectChange}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              alignItems: "flex-end",
            }}
          >
            <Button
              variant="outline"
              onClick={() => {
                setText("");
                setResource([]);
                setShowTabs(false);
              }}
              className={classes.button}
              disabled={!showTabs}
            >
              Disconnect
            </Button>

            <Button
              onClick={showTabs ? () => {} : connect}
              bg={showTabs ? "green" : "blue"}
              disabled={connectDisable}
              sx={{
                "&:hover": {
                  backgroundColor: showTabs ? "green" : "#1B75BC",
                },
              }}
            >
              {loading ? (
                <Loader color="white" size={20} />
              ) : showTabs ? (
                "Connected"
              ) : (
                "Connect"
              )}
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            paddingTop: "40px",
            display: "flex",
            flexDirection: "row",
            gap: "24px",
            paddingLeft: "14px",
          }}
        >
          <Box className={classes.row}>
            <Text className={classes.text}>Connections :</Text>
            <Text className={classes.title1}>{showTabs ? "1" : "0"}</Text>
          </Box>
          <Box className={classes.row}>
            <Text className={classes.text}>Messages :</Text>
            <Text className={classes.title1}>{showTabs ? "1" : "0"}</Text>
          </Box>
        </Box>

        <Box pt={40} mih={289}>
          <Box
            sx={{
              border: "1px solid #EDEDED",
              borderRadius: "8px",
              padding: "20px 16px 20px 16px",
              overflowY: "auto",

              minHeight: "289px",
              maxHeight: "289px",
            }}
          >
            <Text>
              {showTabs ? (
                hl7Message
              ) : (
                <Text color="#999999">
                  The HL7 V2 message will be displayed here
                </Text>
              )}
            </Text>
          </Box>

          <Box>
            <Tabs defaultValue="Details" sx={{ marginTop: "40px" }}>
              <Tabs.List sx={{ width: "230px" }}>
                <Tabs.Tab
                  sx={{ fontWeight: 400, fontSize: "16px" }}
                  value="Details"
                >
                  Details
                </Tabs.Tab>
                <Tabs.Tab
                  sx={{ fontWeight: 400, fontSize: "16px" }}
                  value="FHIR Response"
                >
                  FHIR Response
                </Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel value="Details">
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "24px",
                    padding: "14px",
                  }}
                >
                  <Input.Wrapper label="Resource type">
                    <Input
                      value={showTabs ? resourceType : ""}
                      disabled={true}
                      size="lg"
                    />
                  </Input.Wrapper>
                  <Input.Wrapper label="ACK">
                    <Input
                      value={showTabs ? resource?.body?.ack : ""}
                      disabled={true}
                      size="lg"
                    />
                  </Input.Wrapper>
                  <Box></Box>
                </Box>
              </Tabs.Panel>

              <Tabs.Panel value="FHIR Response">
                <Paper
                  sx={{
                    display: "flex",
                    padding: "14px",
                    borderRadius: "8px",
                    background: "'#FFF",
                    boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
                    flexWrap: "wrap",
                  }}
                >
                  <Text
                    style={{
                      display: "flex",
                      border: "1px solid #ddd",
                      borderRadius: "5px",
                      padding: "12px",
                      flexWrap: "wrap",
                      width: "100%",
                      lineBreak: "auto",
                    }}
                  >
                    <pre>
                      {showTabs ? (
                        <JSONPretty data={resource.body}></JSONPretty>
                      ) : (
                        <Text color="#999999">
                          FHIR Response will show up here
                        </Text>
                      )}
                    </pre>
                  </Text>
                </Paper>
              </Tabs.Panel>
            </Tabs>
          </Box>
        </Box>
      </Box>
      {showInfoModal && (
        <GenericInfoModal
          isOpen={showInfoModal}
          steps={modalSteps}
          modalData={modalData}
          onClose={modalData.onClose}
          onConfirm={modalData.onConfirm}
          setIsPatientModalOpen={setShowModal}
          showStepsImmediately={true}
          autoConfirm={true}
          hl7={true}
        />
      )}
    </Paper>
  );
};
